export const YES = { id: 'yes', label: 'Sì' };
export const NO = { id: 'no', label: 'No' };
export const UNKNOWN = { id: 'unknown', label: 'Non noto' };
